import env from "../env";
import { productDiscriminatorMatches } from "./purchaseBreakdown";

const toProductIdentity = (product) => {
  if (!product || typeof product !== "object") {
    return { id: product, name: null };
  }
  return {
    id:
      product.id ??
      product.value ??
      product.productId ??
      product.product_id ??
      null,
    name: product.name ?? product.productName ?? product.product_name ?? null,
  };
};

export const transformFeeOptions = (feeOptions, chargedProductIds = []) => {
  const HANDLING_FEE_THRESHOLD = env.HANDLING_FEE_THRESHOLD;
  const HANDLING_FEE_UPSELL_ID = env.HANDLING_FEE_UPSELL_ID;
  const normalizedChargedProducts = (
    Array.isArray(chargedProductIds) ? chargedProductIds : []
  ).map(toProductIdentity);

  return feeOptions.map((option) => {
    const isCharged = normalizedChargedProducts.some((product) =>
      productDiscriminatorMatches(
        { id: option.value, name: option.name },
        product,
      ),
    );
    const exceedsThreshold =
      HANDLING_FEE_UPSELL_ID && option.price >= HANDLING_FEE_THRESHOLD;

    let displayText = option.text;
    if (exceedsThreshold) {
      displayText = `${option.text} + Handling Fee`;
    }

    return {
      ...option,
      text: displayText,
      disabled: isCharged,
    };
  });
};
